module.exports = "https://static.wmbcdn.com/uniweb/images/1b0fab63a19ef53fbed869c221598ba6.svg";